import React from "react";
import PropTypes from "prop-types";

import { UIModal } from "../../../ui";
import ClientReportFileRow from "./ClientReportFileRow";
import { formatClientReportSize } from "./clientReportMappers";

import "./ClientReports.scss";

const DownloadAllClientReportsModal = ({
  open,
  labels,
  reports,
  loading,
  downloading,
  onClose,
  onDownload,
}) => {
  const totalSize = reports.reduce((sum, report) => sum + (report.size || 0), 0);
  const sizeLabel = formatClientReportSize(totalSize);
  const hasReports = reports.length > 0;

  return (
    <UIModal
      open={open}
      type="info"
      title={labels.title}
      cancelLabel={labels.cancel}
      confirmLabel={labels.submit}
      onClose={onClose}
      onCancel={onClose}
      onConfirm={onDownload}
      cancelButtonProps={{ disabled: downloading }}
      confirmButtonProps={{
        disabled: !hasReports || loading || downloading,
        appearance: "gradient",
        loading: downloading,
      }}
      PaperProps={{ className: "client-report-modal" }}
      maxWidth="sm"
      fullWidth
    >
      <div className="client-report-modal__body">
        <ClientReportFileRow
          title={
            loading
              ? labels.loading
              : String(labels.selectedCount).replace(
                  "{count}",
                  String(reports.length),
                )
          }
          subtitle={
            !loading && hasReports
              ? [labels.readyToDownload, sizeLabel].filter(Boolean).join(" • ")
              : null
          }
        />
      </div>
    </UIModal>
  );
};

DownloadAllClientReportsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  labels: PropTypes.shape({
    title: PropTypes.node.isRequired,
    cancel: PropTypes.node.isRequired,
    submit: PropTypes.node.isRequired,
    selectedCount: PropTypes.string,
    readyToDownload: PropTypes.string,
    loading: PropTypes.string,
  }).isRequired,
  reports: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  downloading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
};

DownloadAllClientReportsModal.defaultProps = {
  reports: [],
  loading: false,
  downloading: false,
};

export default DownloadAllClientReportsModal;
